import {
	notEnoughConditionsMessage,
	hasNotCommonConditionMessage,
	hasNotConditionForMembersMessage,
	//missingOnlyPointsConditionMessage,
	//missingOnlyPointsConditionForSubscribersMessage
} from '../constants/store-product-messages.constants'

function getParams({ name, quantity, description, spotlightOrder }) {
	const { images, mainImageIndex } = this.getProductImages()
	const { toastError } = this.props

	const notEnoughImages = images.length <= 0
	if (notEnoughImages) return toastError({ message: 'Adicione uma imagem' })

	const paymentConditions = this.getPaymentConditions().map(item => {
		item.price = item.price || 0
		item.points = item.points || 0
		return item
	})

	const hasNotCommonCondition = !paymentConditions.some(
		({ order, forSubscribers }) => !forSubscribers && order === 1
	)
	// if (hasNotCommonCondition)
	// 	return toastError({
	// 		message: hasNotCommonConditionMessage
	// 	})

	const hasNotConditionForMembers = !paymentConditions.some(
		({ order, forSubscribers }) => forSubscribers && order === 1
	)
	// if (hasNotConditionForMembers)
	// 	return toastError({
	// 		message: hasNotConditionForMembersMessage
	// 	})

	const notEnoughConditions =
		paymentConditions.filter(({ forSubscribers }) => !forSubscribers).length <
		1
	if (notEnoughConditions)
		return toastError({
			message: notEnoughConditionsMessage
		})

	if (spotlightOrder === '')
		spotlightOrder = 999

	const params = {
		name,
		images,
		quantity,
		description,
		spotlightOrder,
		mainImageIndex,
		paymentConditions
	}

	return params
}

export { getParams }
